export default __webpack_public_path__ + "static/media/navm.9eeee5b5.jpg";